import React, { useState } from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import ReactPlayer from 'react-player';
import { FormattedMessage } from 'react-intl';

import { Section, Container } from '../global';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

import bcEn1 from '../../../../videos/bc_en_1.mp4';
import bcEn2 from '../../../../videos/bc_en_2.mp4';
import bcEn3 from '../../../../videos/bc_en_3.mp4';
import bcEn4 from '../../../../videos/bc_en_4.mp4';
import bcEn5 from '../../../../videos/bc_en_5.mp4';
import bcEn6 from '../../../../videos/bc_en_6.mp4';
import bcHu1 from '../../../../videos/bc_hu_1.mp4';
import bcHu2 from '../../../../videos/bc_hu_2.mp4';
import bcHu3 from '../../../../videos/bc_hu_3.mp4';
import bcHu4 from '../../../../videos/bc_hu_4.mp4';
import bcHu5 from '../../../../videos/bc_hu_5.mp4';
import bcHu6 from '../../../../videos/bc_hu_6.mp4';
import szEn1 from '../../../../videos/sz_en_1.mp4';
import szEn2 from '../../../../videos/sz_en_2.mp4';
import szEn3 from '../../../../videos/sz_en_3.mp4';
import szEn4 from '../../../../videos/sz_en_4.mp4';
import szEn5 from '../../../../videos/sz_en_5.mp4';
import szEn6 from '../../../../videos/sz_en_6.mp4';
import szHu1 from '../../../../videos/sz_hu_1.mp4';
import szHu2 from '../../../../videos/sz_hu_2.mp4';
import szHu3 from '../../../../videos/sz_hu_3.mp4';
import szHu4 from '../../../../videos/sz_hu_4.mp4';
import szHu5 from '../../../../videos/sz_hu_5.mp4';
import szHu6 from '../../../../videos/sz_hu_6.mp4';

const VideoCarousel = ({ locale, isSalonzone }) => {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);

  const getVideos = () => {
    if (isSalonzone) {
      if (locale === 'hu') {
        return [szHu1, szHu2, szHu3, szHu4, szHu5, szHu6];
      }
      return [szEn1, szEn2, szEn3, szEn4, szEn5, szEn6];
    }
    if (locale === 'hu') {
      return [bcHu1, bcHu2, bcHu3, bcHu4, bcHu5, bcHu6];
    }
    return [bcEn1, bcEn2, bcEn3, bcEn4, bcEn5, bcEn6];
  };

  return (
    <Section id="videos">
      <StyledContainer>
        <Carousel
          width="100%"
          height="100%"
          showStatus={false}
          showThumbs={false}
          onChange={(selectedItemIndex) => {
            setCurrentItemIndex(selectedItemIndex);
          }}
          selectedItem={currentItemIndex}
        >
          <SlideWrapper>
            <p>
              <FormattedMessage id="videos1" />
            </p>
            <ReactPlayer
              config={{ file: { attributes: { playsInline: true } } }}
              width="100%"
              height="100%"
              url={getVideos()[0]}
              playing={currentItemIndex === 0}
              muted
              volume={0}
              onEnded={() => setCurrentItemIndex(currentItemIndex + 1)}
            />
          </SlideWrapper>
          <SlideWrapper>
            <p>
              <FormattedMessage id="videos2" />
            </p>
            <ReactPlayer
              config={{ file: { attributes: { playsInline: true } } }}
              width="100%"
              height="100%"
              url={getVideos()[1]}
              playing={currentItemIndex === 1}
              muted
              volume={0}
              onEnded={() => setCurrentItemIndex(currentItemIndex + 1)}
            />
          </SlideWrapper>
          <SlideWrapper>
            <p>
              <FormattedMessage id="videos3" />
            </p>
            <ReactPlayer
              config={{ file: { attributes: { playsInline: true } } }}
              width="100%"
              height="100%"
              url={getVideos()[2]}
              playing={currentItemIndex === 2}
              muted
              volume={0}
              onEnded={() => setCurrentItemIndex(currentItemIndex + 1)}
            />
          </SlideWrapper>
          <SlideWrapper>
            <p>
              <FormattedMessage id="videos4" />
            </p>
            <ReactPlayer
              config={{ file: { attributes: { playsInline: true } } }}
              width="100%"
              height="100%"
              url={getVideos()[3]}
              playing={currentItemIndex === 3}
              muted
              volume={0}
              onEnded={() => setCurrentItemIndex(currentItemIndex + 1)}
            />
          </SlideWrapper>
          <SlideWrapper>
            <p>
              <FormattedMessage id="videos5" />
            </p>
            <ReactPlayer
              config={{ file: { attributes: { playsInline: true } } }}
              width="100%"
              height="100%"
              url={getVideos()[4]}
              playing={currentItemIndex === 4}
              muted
              volume={0}
              onEnded={() => setCurrentItemIndex(currentItemIndex + 1)}
            />
          </SlideWrapper>
          <SlideWrapper>
            <p>
              <FormattedMessage id="videos6" />
            </p>
            <ReactPlayer
              config={{ file: { attributes: { playsInline: true } } }}
              width="100%"
              height="100%"
              url={getVideos()[5]}
              playing={currentItemIndex === 5}
              muted
              volume={0}
              onEnded={() => setCurrentItemIndex(0)}
            />
          </SlideWrapper>
        </Carousel>
      </StyledContainer>
    </Section>
  );
};

export default VideoCarousel;

const StyledContainer = styled(Container)`
  padding: 20px 0 0px;
  height: 750px;
`;

const SlideWrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 750px;
`;

export const FeatureTitle = styled.h4`
  color: ${(props) => props.theme.color.primary};
  letter-spacing: 0px;
  line-height: 30px;
  margin-bottom: 20px;
  margin-top: 40px;
  text-align: center;
`;
